import type { CustomerPrivacyDashboard } from '../../customerPrivacyApi'
import type { ShopMessageKey } from '../../../i18n'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

export const resolveExportStateLabel = (
  state: CustomerPrivacyDashboard['exportState']['state'],
  t: TranslateFn,
): string => {
  if (state === 'none') return t('customer.privacy.exportState.none')
  if (state === 'processing') return t('customer.privacy.exportState.processing')
  if (state === 'ready') return t('customer.privacy.exportState.ready')
  if (state === 'expired') return t('customer.privacy.exportState.expired')
  return state
}

export const resolvePrivacyAccountStatusLabel = (
  status: CustomerPrivacyDashboard['account']['accountStatus'],
  t: TranslateFn,
): string => {
  if (status === 'active') return t('customer.privacy.accountStatus.active')
  if (status === 'pending_deletion') return t('customer.privacy.accountStatus.pendingDeletion')
  if (status === 'anonymized') return t('customer.privacy.accountStatus.anonymized')
  if (status === 'deleted') return t('customer.privacy.accountStatus.deleted')
  return status
}

export const resolveLatestPrivacyRequest = (dashboard: CustomerPrivacyDashboard) =>
  [...dashboard.requests].sort((left, right) => new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime())[0] ?? null
